import script from "./ActionsMain.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionsMain.vue?vue&type=script&setup=true&lang=js"

import "./ActionsMain.vue?vue&type=style&index=0&id=8171a732&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8171a732"]])

export default __exports__